// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import { NavLink } from 'react-bootstrap'
import './Banner.scss'

export interface ActionItems {
  label: string
  redirectTo: string
  variant?: string
  openInNewTab?: boolean
}

export interface BannerProps {
  title?: string
  customClass?: string
  text?: React.ReactNode
  actions?: ActionItems[] | []
}

const Banner: React.FC<BannerProps> = ({ title, customClass, text, actions = [] }): JSX.Element => {
  return (
    <div className={`banner-overlay px-s7 pb-s11 ${customClass ?? ''}`}>
      <div className="hero-default-background"></div>
      <div className="internal-container gap-s8">
        <div className="banner-headings-container gap-s6">
          <h1 className="text-white">
            <span className="display-2 d-none d-sm-block">{title}</span>
            <span className="display-3 d-block d-sm-none">{title}</span>
          </h1>
          <span className="display-6 d-none d-sm-block">{text}</span>
        </div>
        {actions.length > 0 && (
          <div className="banner-cta gap-s8 py-s4 flex-column flex-sm-row">
            {actions?.map((item: any, index: number) => {
              const intcId = item.label.replaceAll(' ', '-')
              return (
                <NavLink
                  key={index}
                  className={`btn btn-lg btn-${item?.variant ?? 'secondary'}`}
                  href={item.redirectTo}
                  role="button"
                  intc-id={`btn-${intcId}`}
                  data-wap_ref={`btn-${intcId}`}
                  rel="noreferrer"
                  target={item.openInNewTab ? '_blank' : '_self'}
                >
                  {item.label}
                </NavLink>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default Banner
